export default "__VITE_ASSET__CSCR$neS__"